import { InputField } from "@/components/input-field/InputField";
import { numbersWithCommaDecimal } from "@/utils/reg-expressions";
import { Control, FieldValues } from "react-hook-form";

interface Props {
  name: string;
  label: string;
  control: Control<FieldValues>;
  disabled?: boolean;
}

export const NumericCommaFormField = ({ name, label, control, disabled }: Props) => (
  <InputField
    inputName={name}
    labelText={label}
    placeholder="Ingresar"
    control={control}
    allowedPattern={numbersWithCommaDecimal}
    disabled={disabled}
    minHeight="40px"
  />
);
